import { notification } from 'antd';

/**
 * Utility functions for showing toast notifications
 */

export const showSuccess = (message: string, description?: string, duration = 4) => {
  notification.success({
    message,
    description,
    placement: 'topRight',
    duration,
  });
};

export const showError = (message: string, description?: string, duration = 4) => {
  notification.error({
    message,
    description,
    placement: 'topRight',
    duration,
  });
};

export const showWarning = (message: string, description?: string, duration = 4) => {
  notification.warning({
    message,
    description,
    placement: 'topRight',
    duration,
  });
};

export const showInfo = (message: string, description?: string, duration = 4) => {
  notification.info({
    message,
    description,
    placement: 'topRight',
    duration,
  });
};

